import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getWishlistApi, toggleWishlistApi } from '../api/wishlist.api';
import { toast } from 'react-toastify';
import useAuthStore from '../store/authStore';
import { useAuthModal } from '../context/AuthModalContext';

export const useWishlist = () =>
  useQuery({ queryKey: ['wishlist'], queryFn: () => getWishlistApi().then((r) => r.data.data) });

export const useToggleWishlist = () => {
  const qc = useQueryClient();
  const { isAuthenticated } = useAuthStore();
  const { openLoginModal } = useAuthModal();

  return useMutation({
    mutationFn: (productId) => {
      if (!isAuthenticated) {
        openLoginModal();
        return Promise.reject(new Error('not_authenticated'));
      }
      return toggleWishlistApi(productId).then((r) => r.data.data);
    },
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: ['wishlist'] });
      toast.success(data.added ? 'Added to wishlist' : 'Removed from wishlist');
    },
    onError: (e) => {
      if (e?.message !== 'not_authenticated') toast.error('Failed to update wishlist');
    },
  });
};
